import { createFileRoute, Outlet } from '@tanstack/react-router';

import { validateAiHubSearch } from '@/widgets/ai-activity/use-hub-team';

/**
 * `/agents` layout route.  The list lives in the index child (`agents.index`)
 * and the per-agent detail in `agents.$agentId` — this route just renders the
 * matched child via <Outlet/>.  (Previously this route rendered the list
 * directly with no Outlet, so `/agents/:id` could never mount.)  `?team=` is
 * the AI hub's explicit team.
 */
export const Route = createFileRoute('/agents')({
  validateSearch: validateAiHubSearch,
  component: () => <Outlet />,
});
